import { NextResponse } from 'next/server'
import type { NextRequest } from 'next/server'
import { getTokenCookies, getTokenExpiredValidation, } from './app/services/auth/auth.service'


const tokenKey = process.env.NEXT_PUBLIC_TOKEN;
const tokenRefresh = process.env.NEXT_PUBLIC_TOKEN_REFRESH

// This function can be marked `async` if using `await` inside
export function middleware(request: NextRequest) {
  let cookie = request.cookies.get(tokenKey ?? "")
  let cookieRefresh = request.cookies.get(tokenRefresh ?? "")
  
  if (!cookie?.value) { //Verifica se existe token
    request.cookies.delete(tokenKey ?? "")
    request.cookies.delete(tokenRefresh ?? "")
    return NextResponse.redirect(new URL('/auth', request.url))
  }
  else if (getTokenExpiredValidation(cookie.value)) {//Verifica se o token vencido
    if (getTokenExpiredValidation(cookieRefresh ? cookieRefresh.value : "")) {//Token principal expirou / Verifica TokenRefresh vencido
      request.cookies.delete(tokenKey ?? "")
      request.cookies.delete(tokenRefresh ?? "")
      return NextResponse.redirect(new URL('/auth', request.url)) //Se venceu os 2 volta para a tela de login
    }
  }

  return
}

// See "Matching Paths" below to learn more
export const config = {
  matcher: '/system/:path*',
}